/**
 * Simplified Chinese (CNY + SGD) mock transactions. Transfer pairs carry the
 * same `paired*` fields the app's groupTransferPairs() produces, so the real
 * DoubleRow component renders the two-sided sublines. The savings transfer
 * and investment pairs are cross-currency (CNY ↔ SGD).
 */

/** @type {Array<import('../../mock-transactions.js').MockTransaction>} */
export const MOCK_TRANSACTIONS_ZH_CN = [
	{
		id: 'txn-1',
		date: '2026-08-03',
		type: 'Deposit',
		amount: 35000,
		description: '工资',
		accountId: 'acc-checking',
		accountName: '常青银行',
		currency: 'CNY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		tagNames: '收入',
	},
	{
		id: 'txn-2',
		isTransferPair: true,
		date: '2026-08-01',
		type: 'Transfer',
		amount: 5200,
		description: '存入储蓄',
		accountId: 'acc-checking',
		accountName: '常青银行',
		currency: 'CNY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		tagNames: '储蓄',
		pairedType: 'Transfer',
		pairedAmount: 1000,
		pairedCurrencySymbol: 'S$',
		pairedCurrencyDecimalPlaces: 2,
		pairedAccountName: '定期存款',
		pairedAccountId: 'acc-savings',
		pairedDate: '2026-08-01',
	},
	{
		id: 'txn-3',
		isTransferPair: true,
		date: '2026-08-01',
		type: 'Regular Investment',
		amount: 10400,
		description: '基金定投',
		accountId: 'acc-checking',
		accountName: '常青银行',
		currency: 'CNY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		tagNames: '投资',
		pairedType: 'Regular Investment',
		pairedAmount: 2000,
		pairedCurrencySymbol: 'S$',
		pairedCurrencyDecimalPlaces: 2,
		pairedAccountName: '增长型基金',
		pairedAccountId: 'acc-broker',
		pairedDate: '2026-08-01',
	},
	{
		id: 'txn-4',
		isTransferPair: true,
		date: '2026-07-20',
		type: 'Credit Card Payment',
		amount: 12500,
		description: '返利卡还款',
		accountId: 'acc-checking',
		accountName: '常青银行',
		currency: 'CNY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		tagNames: '账单',
		pairedType: 'Credit Card Payment',
		pairedAmount: 12500,
		pairedCurrencySymbol: '\u00A5',
		pairedCurrencyDecimalPlaces: 2,
		pairedAccountName: '返利卡',
		pairedAccountId: 'acc-credit',
		pairedDate: '2026-07-20',
	},
	{
		id: 'txn-5',
		date: '2026-07-24',
		type: 'Withdrawal',
		amount: 1000,
		description: '取现',
		accountId: 'acc-checking',
		accountName: '常青银行',
		currency: 'CNY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		tagNames: '现金',
	},
	{
		id: 'txn-6',
		date: '2026-07-22',
		type: 'Purchase',
		amount: 483,
		description: '超市',
		accountId: 'acc-credit',
		accountName: '返利卡',
		currency: 'CNY',
		currencySymbol: '\u00A5',
		currencyDecimalPlaces: 2,
		tagNames: '餐饮',
	},
	{
		id: 'txn-7',
		date: '2026-07-18',
		type: 'Reward Earned',
		amount: 4200,
		description: '获得里程',
		accountId: 'acc-flight',
		accountName: '飞行里程',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: '里程',
	},
];

/** @type {Array<import('../../mock-transactions.js').MockTransaction>} */
export const MOCK_AVIOS_TRANSACTIONS_ZH_CN = [
	{
		id: 'av-1',
		date: '2026-08-02',
		type: 'Reward Earned',
		amount: 5600,
		description: '酒店住宿奖励',
		accountId: 'acc-flight',
		accountName: '飞行里程',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: '里程',
	},
	{
		id: 'av-2',
		date: '2026-07-28',
		type: 'Reward Redemption',
		amount: 20000,
		description: '奖励机票（经济舱）',
		accountId: 'acc-flight',
		accountName: '飞行里程',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: '旅行',
	},
	{
		id: 'av-3',
		date: '2026-07-18',
		type: 'Reward Earned',
		amount: 4200,
		description: '航班奖励',
		accountId: 'acc-flight',
		accountName: '飞行里程',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: '里程',
	},
];
